<template>
  <div class="mt-4">
    <v-card>
      <v-card-text>
        <v-container class="pa-4 text-center">
          <v-row>
            <v-col>
              <v-stepper v-model="itemsProgresBidangsCalculated">
                <v-stepper-header>
                  <v-stepper-step
                    :complete="itemsProgresBidangsCalculated > 1"
                    step="1"
                  >
                    Pelaksana
                  </v-stepper-step>
                  <v-divider></v-divider>

                  <v-stepper-step
                    :complete="itemsProgresBidangsCalculated > 2"
                    step="2"
                  >
                    PHO
                  </v-stepper-step>
                  <v-divider></v-divider>

                  <v-stepper-step
                    :complete="itemsProgresBidangsCalculated > 3"
                    step="3"
                  >
                    ST-1
                  </v-stepper-step>
                  <v-divider></v-divider>

                  <v-stepper-step
                    :complete="itemsProgresBidangsCalculated > 4"
                    step="4"
                    v-if="itemModified.jenisPekerjaan === 'FSK'"
                  >
                    FHO
                  </v-stepper-step>
                  <v-divider></v-divider>

                  <v-stepper-step
                    :complete="itemsProgresBidangsCalculated > 5"
                    step="5"
                    v-if="itemModified.jenisPekerjaan === 'FSK'"
                  >
                    ST-2
                  </v-stepper-step>
                  <v-divider></v-divider>

                  <v-stepper-step
                    :complete="itemsProgresBidangsCalculated > 6"
                    step=""
                  >
                    CAIR
                  </v-stepper-step>
                  <v-divider></v-divider>
                </v-stepper-header>
              </v-stepper>
            </v-col>
          </v-row>

          <v-row class="fill-height" align="center" justify="center">
            <v-col
              v-for="(item, i) in itemsFileFiltered"
              :key="i"
              class="d-flex child-flex"
              cols="12"
              sm="6"
              md="6"
              lg="4"
            >
              <v-badge
                bordered
                overlap
                :content="lookupBadgeFileType(item.kegiatanType)"
                :color="`${lookupBadgeFileTypeColor(item.kegiatanType)}`"
              >
                <template v-if="true">
                  <div v-if="item.fileType === 'IMAGE'">
                    <v-hover v-slot="{ hover }">
                      <v-card
                        class="align-self-center"
                        :elevation="hover ? 10 : 0"
                        :class="[
                          { 'on-hover': hover },
                          hover
                            ? 'card-hover-opacity'
                            : 'card-not-hover-opacity',
                        ]"
                      >
                        <v-img
                          :lazy-src="lookupImageUrlLazy(item)"
                          :src="lookupImageUrl(item)"
                        >
                          <v-card-title class="text-h6 white--text fill-height">
                            <v-row
                              class="fill-height flex-column"
                              justify="space-between"
                            >
                              <v-spacer />
                            </v-row>
                          </v-card-title>
                        </v-img>
                      </v-card>
                    </v-hover>
                  </div>

                  <div v-else-if="item.fileType === 'MP4'">
                    <v-card>
                      <v-card-title>
                        <Media
                          :kind="'video'"
                          :isMuted="false"
                          :src="downloadFile(item)"
                          :controls="true"
                          :autoplay="false"
                          :loop="true"
                          :ref="'fish'"
                          @pause="handle()"
                          style="height: 320px; width: 320px"
                        >
                        </Media>
                      </v-card-title>
                    </v-card>
                  </div>
                </template>
              </v-badge>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="false">
        <v-container class="text-center">
          <v-row>
            <v-col cols="12" sm="7" md="7">
              <v-btn color="primary" block @click="showDialogUpload"
                ><v-icon>mdi-image</v-icon> Photo
              </v-btn>
            </v-col>
            <v-col cols="12" sm="5" md="5">
              <v-btn
                class="white--text"
                color="red"
                block
                @click="showDialogUploadMp4"
                ><v-icon>mdi-video</v-icon> Vidio
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <UploadImageDialog
      ref="refUploadDialog"
      @eventUploadSuccess="completeUploadSuccess"
    ></UploadImageDialog>
    <UploadMp4Dialog
      ref="refUploadDialogMp4"
      @eventUploadSuccess="completeUploadMp4Success"
    ></UploadMp4Dialog>

    <delete-confirm-dialog
      ref="refDeleteConfirmDialog"
      @eventFromDeleteConfirmDialog1="deleteItemConfirmedSingleSelect"
      @eventFromDeleteConfirmDialog2="deleteItemConfirmedMultiSelect"
    ></delete-confirm-dialog>

    <v-snackbar v-model="snackbar">
      {{ snackBarMesage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FileService from "@/services/apiservices/file-service";
import FKegiatanFileService from "@/services/apiservices/f-kegiatan-file-service";

import FKegiatan from "@/models/f-kegiatan";
import UploadImageDialog from "@/components/utils/UploadImageDialog";
import FKegiatanFile from "@/models/f-kegiatan-file";
import DeleteConfirmDialog from "@/components/utils/DeleteConfirmDialog";

import Media from "@dongido/vue-viaudio";
import UploadMp4Dialog from "@/components/utils/UploadMp4Dialog";

export default {
  components: {
    Media,
    UploadImageDialog,
    UploadMp4Dialog,
    DeleteConfirmDialog,
  },
  props: {
    itemModified: new FKegiatan(),
    itemsFile: [],
  },
  data() {
    return {
      snackbar: false,
      snackBarMesage: "",

      transparent: "rgba(255, 255, 255, 0)",
    };
  },
  computed: {
    itemsFileFiltered() {
      let newItems = this.itemsFile.filter(
        (item) =>
          item.kegiatanType > 1 &&
          (item.fileType === "IMAGE" || item.fileType === "MP4")
      );

      return newItems.sort((a, b) => a.kegiatanType > b.kegiatanType);

      // return this.itemsFile
      //     .filter(item => item.kegiatanType>1 && (item.fileType==="IMAGE" || item.fileType==="MP4") )
      //     .sort(( a, b) => a.kegiatanType > b.kegiatanType)
    },

    itemsProgresBidangsCalculated() {
      let progres = 1;

      if (this.itemModified.cvptBean > 0) progres = 2;

      const itemsFile = this.itemsFile.filter(
        (item) =>
          item.kegiatanType > 1 &&
          (item.fileType === "IMAGE" || item.fileType === "MP4")
      );
      if (this.itemModified.jenisPekerjaan === "NONFSK") {
        itemsFile.forEach((item) => {
          if (item.kegiatanType === 2) {
            if (progres >= 2) progres = 3;
          }
          if (item.kegiatanType === 3) {
            if (progres >= 3) progres = 4;
          }
        });
      } else {
        itemsFile.forEach((item) => {
          if (item.kegiatanType === 2) {
            if (progres >= 2) progres = 3;
          }
          if (item.kegiatanType === 3) {
            if (progres >= 3) progres = 4;
          }
          if (item.kegiatanType === 4) {
            if (progres >= 4) progres = 5;
          }
          if (item.kegiatanType === 5) {
            if (progres >= 5) progres = 6;
          }
        });
      }

      if (
        this.itemModified.nilaiKontrak - 10 <=
        this.itemModified.termin1Cair +
          this.itemModified.termin2Cair +
          this.itemModified.termin3Cair
      ) {
        progres = 7;
      }

      return progres;
    },
  },
  methods: {
    lookupBadgeFileType(kegiatanType) {
      if (kegiatanType === 2) {
        return "PHO";
      } else if (kegiatanType === 3) {
        return "SR-1";
      } else if (kegiatanType === 4) {
        return "FHO";
      } else if (kegiatanType === 5) {
        return "ST-2";
      } else if (kegiatanType === 6) {
        return "FSK";
      } else {
        return "";
      }
    },
    lookupBadgeFileTypeColor(kegiatanType) {
      if (kegiatanType === 2) {
        return "blue";
      } else if (kegiatanType === 3) {
        return "grey";
      } else if (kegiatanType === 4) {
        return "red";
      } else if (kegiatanType === 5) {
        return "green";
      } else if (kegiatanType === 6) {
        return "yellow";
      } else {
        return "";
      }
    },

    handle() {
      // console.log('Video paused!, playing in 2 sec...')

      setTimeout(() => {
        this.$refs.fish.play();
      }, 2000);
    },

    showDialogUpload() {
      if (
        this.itemModified.description !== undefined &&
        this.itemModified.fdivisionBean !== undefined
      ) {
        this.$refs.refUploadDialog.showDialog();
      } else {
        this.snackBarMesage = "Deskripsi dan Divisi harus diisi dahulu";
        this.snackbar = true;
      }
    },
    completeUploadSuccess: function (val) {
      if (val.fileName !== "") {
        let fkegiatanFileBean = new FKegiatanFile(
          0,
          this.itemModified.id,
          val.fileName,
          val.description,
          "IMAGE",
          5,
          true
        );
        fkegiatanFileBean.modifiedBy = this.$store.state.auth.user.username;

        FKegiatanFileService.createFKegiatanFile(fkegiatanFileBean).then(
          (response) => {
            // console.log(response)
            this.$refs.refUploadDialog.closeDialog();
            //Just REfresh files
            this.$emit("retrieveFiles", response.dummy);
          },
          (error) => {
            console.log(error.message);
          }
        );
      }
    },

    showDialogUploadMp4() {
      if (
        this.itemModified.description !== undefined &&
        this.itemModified.fdivisionBean !== undefined
      ) {
        this.$refs.refUploadDialogMp4.showDialog();
      } else {
        this.snackBarMesage = "Deskripsi dan Divisi harus diisi dahulu";
        this.snackbar = true;
      }
    },
    completeUploadMp4Success: function (val) {
      if (val.fileName !== "") {
        let fkegiatanFileBean = new FKegiatanFile(
          0,
          this.itemModified.id,
          val.fileName,
          val.description,
          "MP4",
          2,
          true
        );
        fkegiatanFileBean.modifiedBy = this.$store.state.auth.user.username;

        FKegiatanFileService.createFKegiatanFile(fkegiatanFileBean).then(
          (response) => {
            // console.log(response)
            this.$refs.refUploadDialog.closeDialog();
            //Just REfresh files
            this.$emit("retrieveFiles", response.dummy);
          },
          (error) => {
            console.log(error.message);
          }
        );
      }
    },
    downloadFile(item) {
      // this.itemSelectedIndex = this.itemsFile.indexOf(item)
      // this.itemSelected = Object.assign({}, item)

      // console.log(`File nya adalah ${item.fileName}`)
      // console.log(`${FileService.fileStreamMp4File(item.fileName)}`)

      return FileService.fileStreamMp4File(item.fileName);
    },
    deleteDialogShow(item) {
      // console.log(item)
      this.itemSelectedIndex = this.itemsFile.indexOf(item);
      this.itemSelected = Object.assign({}, item);
      // this.myConfirmDelete = true
      this.$refs.refDeleteConfirmDialog.showDialog(
        this.itemSelectedIndex,
        item.description
      );
    },

    deleteItemConfirmedSingleSelect(index) {
      console.log("delete SingleItem: " + index);

      const deletedItem = this.itemsFile[this.itemSelectedIndex];
      FKegiatanFileService.deleteFKegiatanFile(deletedItem.id).then(
        () => {
          this.itemsFile.splice(this.itemSelectedIndex, 1);
          this.closeDialog();
        },
        (error) => {
          console.log(error);
          this.snackBarMesage = "gagal hapus (digunakan oleh data anakk)";
          this.snackbar = true;
          this.$refs.refDeleteConfirmDialog.setDialogState(false);
        }
      );
      FileService.deleteImage(deletedItem.fileName).then(
        () => {
          // console.log(response.data)
        },
        (error) => {
          console.log(error.response);
        }
      );
    },
    deleteItemConfirmedMultiSelect(items) {
      console.log(items);
    },
    closeDialog() {
      // this.myConfirmDialog = false
      this.formMode = "";
      this.$refs.refDeleteConfirmDialog.setDialogState(false);
      this.$refs.refFormDialog.setDialogState(false);

      this.$nextTick(() => {
        this.itemSelected = Object.assign({}, new FKegiatan());
        this.itemSelectedIndex = -1;
      });
    },

    lookupImageUrl(item) {
      if (item.fileName === undefined) {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_high(item.fileName);
      }
    },
    lookupImageUrlLazy(item) {
      // return './assets/images/no_image_available.jpeg'
      return FileService.image_url_verylow(item.fileName);
    },
    lookupImageUrlVideo(item) {
      console.log(item);
      return "../assets/images/vidio.png";
    },
  },
};
</script>

<style scoped>
/*.card-hover-opacity{*/
/*  opacity: 0.4;*/
/*}*/
/*.card-not-hover-opacity{*/
/*  opacity: 1;*/
/*  !*transition: opacity .4s ease-in-out;*!*/
/*  transition: opacity .4s ease-in-out;*/
/*}*/

/*.show-btns {*/
/*  color: red !important;*/
/*  opacity: 1;*/
/*}*/
</style>